import React from "react";
import Project from "../Project";

// an array of projects -> each project has a title, github link, image link, deployed link
const projects = [
  {
    title: "DnD Commerce",
    imageLink: "images/DnD-storefront.gif",
    GitHubLink: "https://github.com/fzhao888/DNDCommerce",
    deployedLink: "https://dnd-commerce-3caad9c94c17.herokuapp.com/",
  },  
  {
    title: "ReelDeel",
    imageLink: "images/search-results.png",
    GitHubLink: "https://github.com/fzhao888/ReelDeal",
    deployedLink: "https://fzhao888.github.io/ReelDeal/",
  },

  {
    title: "TechBlog",
    imageLink: "images/techblog.png",
    GitHubLink: "https://github.com/fzhao888/Tech-Blog",
    deployedLink: "https://frank-tech-blog-7da66f465c95.herokuapp.com/",
  },
  {
    title: "Work Day Scheduler",
    imageLink: "images/Work-Day-Scheduler-Sample.png",
    GitHubLink: "https://github.com/fzhao888/Work-Day-Scheduler",
    deployedLink: "https://fzhao888.github.io/Work-Day-Scheduler/",
  },
];

export default function Portfolio() {
  return (
    <div>
      <section className="portfolio">
        <Project projects={projects} />
      </section>
    </div>
  );
}
